import { FetchRequest } from "./fetchRequest";

export const TARGETING = {
  CPS_AVAILABLE: "pub_rate_model_cps",
  CONTENT_LOCKER_AVAILABLE: "content_locker_availability",
  FULL_STORY_ON: "full_story_on",
  DIRECT_LINKS_AVAILABLE: "pub_direct_links",
};

class Targeting {
  async check(targeting) {
    return await FetchRequest({
      url: `/api/notix/collections/targeting/${targeting}/`,
      method: "GET",
      useToken: true,
    });
  }

  async getTargetingsByType(type) {
    return await FetchRequest({
      url: `/api/notix/collections/targeting/${type}/`,
      method: "GET",
      useToken: true,
    });
  }

  async getTargetingsLanguage() {
    return await FetchRequest({
      url: `/api/notix/collections/targeting/language/`,
      method: "GET",
      useToken: true,
    });
  }

  async getTargetingsBrowser() {
    return await FetchRequest({
      url: `/api/notix/collections/targeting/browser/`,
      method: "GET",
      useToken: true,
    });
  }

  async getTargetingsDevice() {
    return await FetchRequest({
      url: `/api/notix/collections/targeting/device/`,
      method: "GET",
      useToken: true,
    });
  }

  async getTargetingsOs() {
    return await FetchRequest({
      url: `/api/notix/collections/targeting/os/`,
      method: "GET",
      useToken: true,
    });
  }




}

const targetingInstance = new Targeting();

export default targetingInstance;